import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-11"
}
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-9" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Característica")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-11" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Item/Valor")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Imprimir na Venda/NF-e")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" })
], -1)
const _hoisted_9 = { class: "ant-col ant-col-xs-2 ant-col-xl-1" }
const _hoisted_10 = {
  title: "Arraste para cima ou para baixo para ordenar as características",
  class: "ss-mover ss-alinhar-centro"
}
const _hoisted_11 = { class: "ant-col ant-col-xs-22 ant-col-xl-8" }
const _hoisted_12 = { class: "ss-margin-campos" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_14 = {
  key: 0,
  class: "ss-margin-campos"
}
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = {
  key: 1,
  class: "ss-margin-campos"
}
const _hoisted_18 = {
  key: 2,
  class: "ss-margin-campos"
}
const _hoisted_19 = {
  key: 3,
  class: "ss-margin-campos"
}
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_23 = { class: "ant-col ant-col-xs-20 ant-col-xl-3 ss-alinhar-centro" }
const _hoisted_24 = { class: "ant-col ant-col-xs-4 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_caracteristica = _resolveComponent("selecionar-caracteristica")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_caracteristica_item = _resolveComponent("selecionar-caracteristica-item")!
  const _component_selecionar_caracteristica_cor = _resolveComponent("selecionar-caracteristica-cor")!
  const _component_selecionar_caracteristica_sub_item = _resolveComponent("selecionar-caracteristica-sub-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.state.novaCaracteristica.tipo === undefined ? 'ant-col ant-col-xs-24 ant-col-xl-20' : 'ant-col ant-col-xs-24 ant-col-xl-9')
          }, [
            _createVNode(_component_a_form_item, {
              label: "Característica",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_caracteristica, {
                  ref: "campoNovaCaracteristica",
                  codigoSelecionado: _ctx.state.novaCaracteristica.codigoCaracteristica,
                  "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristica) = $event)),
                  onChange: _ctx.obterDadosCaracteristica,
                  empresas: _ctx.props.empresas
                }, null, 8, ["codigoSelecionado", "onChange", "empresas"])
              ]),
              _: 1
            })
          ], 2),
          (_ctx.state.novaCaracteristica.tipo !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.verificaPreenchimentoCampoValor(_ctx.state.novaCaracteristica.tipo))
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      label: "Valor",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.TextoLivre)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              class: "ant-input",
                              maxlength: "250",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.novaCaracteristica.caracteristicaPersonalizada) = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.state.novaCaracteristica.caracteristicaPersonalizada]
                            ])
                          : (_ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.Numero || _ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.Decimal)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "number",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.novaCaracteristica.caracteristicaPersonalizada) = $event))
                              }, null, 512)), [
                                [_vModelText, _ctx.state.novaCaracteristica.caracteristicaPersonalizada]
                              ])
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.ListaSimples)
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 1,
                        label: "Selecione um item",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_caracteristica_item, {
                            empresas: _ctx.props.empresas,
                            codigoSelecionado: _ctx.state.novaCaracteristica.codigoCaracteristicaItem,
                            "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristicaItem) = $event)),
                            codigoCaracteristica: _ctx.state.novaCaracteristica.codigoCaracteristica
                          }, null, 8, ["empresas", "codigoSelecionado", "codigoCaracteristica"])
                        ]),
                        _: 1
                      }))
                    : (_ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.Cor)
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 2,
                          label: "Selecione um item",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_caracteristica_cor, {
                              empresas: _ctx.props.empresas,
                              codigoSelecionado: _ctx.state.novaCaracteristica.codigoCaracteristicaItem,
                              "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristicaItem) = $event)),
                              codigoCaracteristica: _ctx.state.novaCaracteristica.codigoCaracteristica
                            }, null, 8, ["empresas", "codigoSelecionado", "codigoCaracteristica"])
                          ]),
                          _: 1
                        }))
                      : (_ctx.verificaPreenchimentoSubItem(_ctx.state.novaCaracteristica.tipo))
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 3,
                            label: "Selecione um item",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_selecionar_caracteristica_item, {
                                    empresas: _ctx.props.empresas,
                                    codigoSelecionado: _ctx.state.novaCaracteristica.codigoCaracteristicaItem,
                                    "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristicaItem) = $event)),
                                    codigoCaracteristica: _ctx.state.novaCaracteristica.codigoCaracteristica,
                                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.novaCaracteristica.codigoCaracteristicaSubItem = 0))
                                  }, null, 8, ["empresas", "codigoSelecionado", "codigoCaracteristica"])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_selecionar_caracteristica_sub_item, {
                                    empresas: _ctx.props.empresas,
                                    codigoSelecionado: _ctx.state.novaCaracteristica.codigoCaracteristicaSubItem,
                                    "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristicaSubItem) = $event)),
                                    filtrarApenasItemPreenchido: true,
                                    codigoCaracteristicaItem: _ctx.state.novaCaracteristica.codigoCaracteristicaItem,
                                    placeholder: _ctx.state.novaCaracteristica.codigoCaracteristicaItem === undefined ? '' : 'Digite para selecionar um sub item',
                                    disabled: (_ctx.state.novaCaracteristica.codigoCaracteristicaItem === undefined)
                                  }, null, 8, ["empresas", "codigoSelecionado", "codigoCaracteristicaItem", "placeholder", "disabled"])
                                ])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_form_item, {
              label: " ",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-secondary ant-btn-block",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.adicionarCaracteristica()))
                }, " Adicionar ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_8,
        (_ctx.computedCaracteristicas.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhuma característica foi adicionada ainda"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form, {
          name: "ss-form-produto-caracteristicas",
          class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal",
          model: _ctx.computedCaracteristicas
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              modelValue: _ctx.computedCaracteristicas,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedCaracteristicas) = $event)),
              "item-key": "index",
              handle: ".ss-mover"
            }, {
              item: _withCtx(({ element, index }) => [
                (_openBlock(), _createElementBlock("div", {
                  class: "ant-row ss-grade-personalizada-linha",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_icone, {
                        style: {"font-size":"15px"},
                        nome: "ordenar-lista"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_selecionar_caracteristica, {
                        empresas: _ctx.props.empresas,
                        codigoSelecionado: element.codigoCaracteristica,
                        "onUpdate:codigoSelecionado": ($event: any) => ((element.codigoCaracteristica) = $event),
                        disabled: true
                      }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.verificaPreenchimentoCampoValor(element.tipo))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (element.tipo === _ctx.ETipoCaracteristica.TextoLivre)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                class: "ant-input",
                                maxlength: "250",
                                "onUpdate:modelValue": ($event: any) => ((element.caracteristicaPersonalizada) = $event)
                              }, null, 8, _hoisted_15)), [
                                [_vModelText, element.caracteristicaPersonalizada]
                              ])
                            : (element.tipo === _ctx.ETipoCaracteristica.Numero || element.tipo === _ctx.ETipoCaracteristica.Decimal)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  type: "number",
                                  class: "ant-input",
                                  "onUpdate:modelValue": ($event: any) => ((element.caracteristicaPersonalizada) = $event)
                                }, null, 8, _hoisted_16)), [
                                  [_vModelText, element.caracteristicaPersonalizada]
                                ])
                              : _createCommentVNode("", true)
                        ]))
                      : (element.tipo === _ctx.ETipoCaracteristica.ListaSimples)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_selecionar_caracteristica_item, {
                              empresas: _ctx.props.empresas,
                              codigoSelecionado: element.codigoCaracteristicaItem,
                              "onUpdate:codigoSelecionado": ($event: any) => ((element.codigoCaracteristicaItem) = $event),
                              codigoCaracteristica: element.codigoCaracteristica,
                              limparSelecao: false
                            }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "codigoCaracteristica"])
                          ]))
                        : (element.tipo === _ctx.ETipoCaracteristica.Cor)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_selecionar_caracteristica_cor, {
                                empresas: _ctx.props.empresas,
                                codigoSelecionado: element.codigoCaracteristicaItem,
                                "onUpdate:codigoSelecionado": ($event: any) => ((element.codigoCaracteristicaItem) = $event),
                                codigoCaracteristica: element.codigoCaracteristica,
                                limparSelecao: false
                              }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "codigoCaracteristica"])
                            ]))
                          : (_ctx.verificaPreenchimentoSubItem(element.tipo))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_selecionar_caracteristica_item, {
                                      empresas: _ctx.props.empresas,
                                      codigoSelecionado: element.codigoCaracteristicaItem,
                                      "onUpdate:codigoSelecionado": ($event: any) => ((element.codigoCaracteristicaItem) = $event),
                                      codigoCaracteristica: element.codigoCaracteristica,
                                      limparSelecao: false,
                                      onChange: ($event: any) => (element.codigoCaracteristicaSubItem = 0)
                                    }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "codigoCaracteristica", "onChange"])
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_component_selecionar_caracteristica_sub_item, {
                                      empresas: _ctx.props.empresas,
                                      codigoSelecionado: element.codigoCaracteristicaSubItem,
                                      "onUpdate:codigoSelecionado": ($event: any) => ((element.codigoCaracteristicaSubItem) = $event),
                                      codigoCaracteristicaItem: element.codigoCaracteristicaItem,
                                      filtrarApenasItemPreenchido: true,
                                      limparSelecao: false
                                    }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "codigoCaracteristicaItem"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_selecionar_sim_nao, {
                      class: "ss-tamanho-completo",
                      radioButton: true,
                      valor: element.imprimirVendaNfe,
                      "onUpdate:valor": ($event: any) => ((element.imprimirVendaNfe) = $event)
                    }, null, 8, ["valor", "onUpdate:valor"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary",
                      onClick: ($event: any) => (_ctx.removerCaracteristica(index))
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ], 8, _hoisted_25)
                  ])
                ]))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}